import React, { PureComponent } from 'react'
import styled from 'styled-components';
import GlobalStyle from 'stylecomponents/globalstyle';
import PageButton from './PageButton';

const Container = styled.div`
  display: flex;
`

const Button = GlobalStyle.BasicBlock.extend`
  background-color: ${props => props.highlight? '#F75C2F' : '#f3f3f3'};
  color: ${props => props.highlight? '#FFF' : '#7D8995'};
  font-size: 14px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 2px;
  cursor: pointer;
`

const Icon = styled.i`
  font-size: 16px;
  color: #7D8995;
`

export default class PaginationView extends PureComponent {
  static defaultProps = {
    total: 50,
    limit: 15,
    nowPage: 1,
    paginationLimit: 10,
  }

  changePage = num => {
    const { limit } = this.props;
    this.props.changePage(num, limit * (num - 1));
  }
  
  render() {
    const { total, limit, nowPage, paginationLimit } = this.props;
    const pages = Array.from({ length: Math.ceil(total / limit) }, (_, index) => {
      return index + 1;
    }).filter((page, index) => {
      if(page === 1) return true;
      else if (
        page >= (nowPage - (paginationLimit / 2)) &&
        page <= nowPage
      )
        return true;
      else if(
        page <= (nowPage + (paginationLimit / 2)) &&
        page >= nowPage
      ) 
        return true;

      return false;
    });
    
    return (
      <Container>
        <Button onClick={this.props.changePageToPrev}>
          <Icon className="zmdi zmdi-chevron-left" />
        </Button>
        {pages.map(page => {
          return (
            <PageButton
              isActive={nowPage === page}
              key={page}
              num={page}
              changePage={this.changePage}
            />
          );
        })}
        <Button onClick={this.props.changePageToNext}>
          <Icon className="zmdi zmdi-chevron-right" />
        </Button>
      </Container>
    )
  }
}
